// extracted by mini-css-extract-plugin
export default {"wrapper":"sidebaricons_wrapper__4mt71","main":"sidebaricons_main__Jw9PL","subjects_menu_wrapper":"sidebaricons_subjects_menu_wrapper__QARGd"};